import axios from "axios";
import apiConfig from "../config/apiConfig";
import constants from "../library/constants";

export default class ApiCheckout {
    constructor() {
        this.api_token = null;
        this.client = null;
        this.api_url = apiConfig.checkout.checkoutApi; // "http://localhost:8080/api/"; // to update
    }

    init = () => {
        
        let headers = {
            'Content-Type': 'application/json'
        };

        this.client = axios.create({
            baseURL: this.api_url,
            timeout: 31000,
            headers: headers,
        });

        return this.client;
    };

    CheckoutCreateSession = (orderData, displayConfig, customerData, billingAddressData, merchantId) => {

        const payload = {
                order: orderData,
                displayConfig: displayConfig,
                paymentMethods: ["CARD", "PAYPAL", "APPLE_PAY", "GOOGLE_PAY"]
            };

        // Add merchantId if provided
        if (merchantId) {
            payload.merchantId = merchantId;
        }

        // Add customer data if provided
        if (customerData) {
            payload.customer = customerData;
        }

        // Add billing address if provided
        if (billingAddressData) {
            payload.billingAddress = billingAddressData;
        }

        return this.init().post(`/session/create`, payload);
    }

    createTerminalSale = async (amount) => {
        const amountInCents = Math.round(amount * 100);
        
        return this.init().post(`/payments/terminal/sale`, amountInCents);
    }
    
}
